import styled from "@emotion/styled"
import { Box } from "@chakra-ui/react"

// * NEEDS REFACTOR

export const StyledCarNumberBox = styled(Box)`
    .css-5iumm0 {
      width: 119px;
      height: 37px;
      border: 2px solid;
      border-color: var(--chakra-colors-input_border_color_primary);
    }

    .css-1h5t5ny {
      font-weight: 600;
      font-size: var(--chakra-fontSizes-l);
    }
`
